import App from '../index.js';
import QRCodeStyling from 'qr-code-styling';

App.BotSetting = (function () {
    let displayQRCodeLogo = true;
    let qrCode = null;
    const elPrimaryColor = $('#primary_color');
    const elSecondColor = $('#secondary_color');

    function initImageInputs () {
        $('.img-input input[type=file]').on('change', function ( e ) {
            const fileInput = e.target;
            const [ file ] = fileInput.files;
            const elImgPreview = $(this).closest('.img-input').find('.img-preview');
            if (file) {
                let img = URL.createObjectURL(file);
                elImgPreview.addClass('active');
                elImgPreview.find('img').attr('src', img);
            } else {
                elImgPreview.removeClass('active');
            }
        });
    }

    function initColorPickers () {

        elPrimaryColor.spectrum({
            color: elPrimaryColor.val(),
            change: function ( color ) {
                $('#primary_color_text').val(color.toHexString())
            }
        });

        $("#primary_color_text").on('click', function () {
            elPrimaryColor.spectrum("toggle");
            return false;
        });

        elSecondColor.spectrum({
            color: elSecondColor.val(),
            change: function ( color ) {
                $('#secondary_color_text').val(color.toHexString())
            }
        });

        $("#secondary_color_text").on('click', function () {
            elSecondColor.spectrum("toggle");
            return false;
        });
    }

    function initWysiwyg (selector) {
        App.wysiwygEditor(selector, 400, function ( data ) {
        }, function ( el, content ) {
            el.val(content);
        });
    }

    function toggleContent () {
        const el = $(this),
            elParent = el.closest('.toggle-wrapper'),
            isSelected = parseInt(el.val()) > 0;

        if (isSelected) {
            elParent.find('.toggle-field-prompt input').val(15);
        }

        elParent.find('.toggle-field-prompt').toggleClass('d-none', !isSelected);
    }

    function toggleOnlyFillOutOnce () {
        const el = $(this),
            elDelays = $('[name="enable_auto_restart_delay"], [name="enable_no_interaction_restart_delay"], [name="enable_show_start_over_button"]'),
            elDelaysNumber = $('[name="auto_restart_delay"], [name="no_interaction_restart_delay"]');

        if (parseInt(el.val())) {
            $('#enable_auto_restart_delay_no, #enable_no_interaction_restart_delay_no, #enable_show_start_over_button_no').prop('checked', true).attr('checked', 'checked');
            $('.toggle-wrapper .toggle-field-prompt').addClass('d-none');
            elDelaysNumber.val(15).attr('disabled', 'disabled');
            elDelays.attr('disabled', 'disabled');
        } else {
            elDelays.removeAttr('disabled');
            elDelaysNumber.removeAttr('disabled');
        }
    }

    function setupQRCode () {
        const elQRCode = $('#qrcode');
        const logoUrl = elQRCode.data('logo-url');
        const url = elQRCode.data('url');

        elQRCode.empty();

        let options = {
            width: 900,
            height: 900,
            type: "canvas",
            data: url,
            dotsOptions: {
                color: '#000000',
                type: "rounded"
            },
            backgroundOptions: {
                color: "#ffffff",
            },
        };

        if (logoUrl && displayQRCodeLogo) {
            options = {
                ...options,
                image: logoUrl,
                imageOptions: {
                    crossOrigin: "anonymous",
                    margin: 5
                }
            }
        }

        qrCode = new QRCodeStyling(options);

        qrCode.append(document.getElementById("qrcode"));

        $('#qrcode_download').removeClass('d-none');
    }

    return {
        init: function () {
            initImageInputs();
            initColorPickers();
            initWysiwyg('#thank_you_message');
            initWysiwyg('#instructions');
            setupQRCode();

            $('body')
                .on('change', '[name="enable_auto_restart_delay"], [name="enable_no_interaction_restart_delay"]', toggleContent)
                .on('change', '[name="only_fill_out_once"]', toggleOnlyFillOutOnce)
                .on('change', '[name="display_logo_on_qrcode"]', function (  ){
                    displayQRCodeLogo = parseInt($(this).val()) === 1
                    setupQRCode();
                }).on('click', '#qrcode_download:not(.disabled)', function ( e ) {
                    const el = $(this);
                    $(this).text('Downloading').addClass('disabled');
                    e.preventDefault();
                    if(qrCode) {
                        const name = $('#qrcode').data('name');
                        qrCode.download({ name: name + "-qrcode", extension: "png" }).then((buffer) => {
                            setTimeout(() => {
                                el.text('Download QR Code').removeClass('disabled');
                            }, 1000);
                        });
                    }
                });
        }
    };

})();

// Provide the route name
App.registerRoute('organizations.surveys.setting', App.BotSetting.init);

export default App.BotSetting;
